
  <div class='custom-grid mb-4 '>

    <div class="d-flex justify-content-around">
      <div *ngIf="!roteiroCrossdocking">
          <span class="titulo">{{ tituloPrincipal }} </span>
          <p class="tit-principal mb-0" [ngStyle]="{'text-align': centralizarTexto ? 'center' : 'left'}"> {{ infoPrincipal }}</p>
      </div>
      <div class="separator"  *ngIf="!roteiroCrossdocking"></div>
      <div>
          <span class="titulo"> {{ tituloSecundario }}</span>
          <p class="tit-principal mb-0" [ngStyle]="{'text-align': centralizarTexto ? 'center' : 'left'}"> {{ infoSecundario }}</p>
      </div>      
    </div>
    
    <ng-content ></ng-content>
      
  </div>
